exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrapper{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100vw;\r\n    height: 100%;\r\n    background-color: rgba(245, 245,245,0.4);\r\n    position: fixed;\r\n    z-index: 999999;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n  }\r\n  .loader-wrapper img{\r\n    width: 100px;\r\n    -webkit-filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.9));\r\n            filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.9))\r\n  }\r\n  .loader-wrapper .mat-progress-spinner{\r\n    max-height: 30vh !important;\r\n  }\r\n  .mat-progress-bar{\r\n    position: fixed;\r\n    top: 86px;\r\n    left: 0;\r\n    right: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/loader/loader.component.css
// module id = ../../../../../src/app/directive/loader/loader.component.css
// module chunks = main